/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSyncEntityMetadataRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {GetSyncEntityMetadataResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const getSyncEntityMetadata = (request: GetSyncEntityMetadataRequest, options?: CashRequestOptions) => post<GetSyncEntityMetadataRequest, GetSyncEntityMetadataResponse>("/2.0/cash/get-sync-entity-metadata", request, {...options, rejectOnError: true })